import { Link } from "react-router-dom";
import { Workflow } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import "./mindshareGuideLink.css";

export default function MindshareGuideLink({ dashboard = "mindshare", label = "mindSHARE" }) {
  const { currentUser, loadingUser } = useAuth();
  if (loadingUser || !currentUser?.is_admin) return null;
  return (
    <Link className="ms-guide-link" to={`/admin/architecture/${dashboard}`}
      aria-label={`Inside ${label} (admin only)`} title={`Inside ${label} / admin only`}>
      <Workflow size={16} aria-hidden="true" />
    </Link>
  );
}
